import { defineMessages } from "react-intl"

export const PRICING_TABLE_MESSAGES = defineMessages({
    default_group_name: {
        id: "pricing.pricing_table.default_group_name",
        defaultMessage: "Unnamed group",
    }
})



// WEBPACK FOOTER //
// ./src/utils/pricing/messages.ts